import * as React from "react"

const LinkSVG = (props) => (
  <svg
    width={16}
    height={16}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>Mask</title>
    <defs>
      <path
        d="M14.288 2.99 9.061 8.218 7.646 6.803l5.307-5.307-2.376-.09-.042-1.113 4.768.182.182 4.768-1.113-.042-.084-2.21ZM1.75 14.25h10.5V9H14v7H0V2h7v1.75H1.75v10.5Z"
        id="a"
      />
    </defs>
    <use fillRule="nonzero" xlinkHref="#a" />
  </svg>
)
export default LinkSVG
